// extracted by mini-css-extract-plugin
export var container = "_9h-0";
export var error = "_9h-9";
export var label = "_9h-5";
export var light = "_9h-6";
export var md = "_9h-3";
export var sm = "_9h-2";
export var thin = "_9h-8";
export var thinBold = "_9h-7";
export var vertical = "_9h-4";
export var xs = "_9h-1";